var Dispatcher = require('./Dispatcher');

/**
 * Action class
 */


  /**
   * Constructs an Action object
   *
   * @param {function} callback - Callback method for Action
   * @constructor
   */
  function Action(callback) {"use strict";
    this.callback = callback;
  }

  /**
   * Calls callback method from Dispatcher
   *
   * @param {...*} arguments - arguments for callback method
   * @constructor
   */
  Action.prototype.dispatch=function() {"use strict";
    Dispatcher.dispatch(this.callback.apply(this, arguments));
  };


module.exports = Action;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mcfly/lib/Action.js
 ** module id = 19
 ** module chunks = 0
 **/